export const categories = [
      {
          "id": 1,
          "urlName": "/",
          "name": "Trang chủ",
          "topics": []
      },
      {
          "id": 2,
          "urlName": "/dich-vu-chinh",
          "name": "Dịch vụ vận chuyển",
          "topics": []
      },
      {
          "id": 3,
          "urlName": "/du-an-da-van-chuyen",
          "name": "Dự án đã vận chuyển",
          "topics": []
      },
      {
          "id": 4,
          "urlName": "/bang-gia-van-tai-hang-hoa",
          "name": "Bảng giá",
          "topics": []
      },
      {
          "id": 5,
          "urlName": "/tin-tuc",
          "name": "Tin tức",
          "topics": []
      },
      {
          "id": 6,
          "urlName": "/lien-he",
          "name": "Liên hệ",
          "topics": []
      }
  ]